import { isNullOrUndefined } from '../../util/is-null-or-undefined.util';

export interface IMesSelecaoConfig {
  placeHolder?: string;
  valorInicial?: Date;
  minAno?: number;
  minMes?: number;
  maxAno?: number;
  maxMes?: number;
  locale?: string;
  displayMesExtenso?: boolean;
}

export interface IDataSelecaoItem {
  text: string;
  value: number;
  classItem: string;
  bloqueado: boolean;
}

export class MesSelecao {
  estado: string;
  selectionItems: Array<IDataSelecaoItem>;
  selecaoMes: string;
  selecaoMesIndex: number;
  selecaoAno: number;
  displayMes: string;
  displayMesIndex: number;
  displayAno: number;
  anoMin: number;
  mesMin: number;
  anoMax: number;
  mesMax: number;
  private mesLista;

  constructor(
    mesLista: string[],
    anoMax: number = 0,
    mesMax: number = 12,
    anoMin: number = 0,
    mesMin: number = 0
  ) {
    this.anoMax = anoMax;
    this.mesMax = mesMax;
    this.anoMin = anoMin;
    this.mesMin = mesMin;
    this.mesLista = mesLista;
    this.estado = 'fechado';
    const currentDate = new Date();
    this.definirDataCorrente(currentDate);
  }

  definirEstado() {
    this.estado = this.estado === 'fechado' ? 'aberto' : 'fechado';
  }

  preencherListaMesItem(currentDate: Date) {
    this.selectionItems = [];
    let className = '';
    this.mesLista.forEach((v: string, i: number) => {
      i++;
      className = 'mes-item-bloqueado';

      // O ano máximo é menor igual ao ano corrente
      if (this.anoMax <= currentDate.getFullYear()) {
        // Quando o ano máximo é o mesmo que o mínimo
        if (this.anoMax === this.anoMin) {
          if (this.mesMin <= this.mesMax) {
            if (i >= this.mesMin && i <= this.mesMax) {
              className = 'mes-item-desbloqueado';
            }
          }
          // O ano minimo é menor que o ano máximo
        } else if (this.anoMin < this.anoMax) {
          if (i <= this.mesMax) {
            className = 'mes-item-desbloqueado';
          }
        }
        // Quando ano corrente no datepicker for maior que o ano mínimo e menor que o ano máximo todos os meses devem estar desbloqueados
      } else if (
        this.anoMin < this.displayAno &&
        this.anoMax > this.displayAno
      ) {
        className = 'mes-item-desbloqueado';
        // O ano corrente no datepicker for igual ou maior ao ano mínimo
      } else if (this.anoMin <= this.displayAno) {
        if (i >= this.mesMin) {
          className = 'mes-item-desbloqueado';
        }
      }

      this.selectionItems.push({
        text: v,
        value: i,
        classItem: className,
        bloqueado: className === 'mes-item-bloqueado',
      });
    });
  }

  definirDataCorrente(currentDate: Date) {
    this.preencherListaMesItem(currentDate);

    this.displayMes = this.mesLista[currentDate.getMonth() - 1];
    this.displayMesIndex = currentDate.getMonth();
    this.displayAno =
      this.anoMax !== 0 && this.anoMax < currentDate.getFullYear()
        ? this.anoMax
        : currentDate.getFullYear();

    this.selecaoMes = this.displayMes;
    this.selecaoMesIndex = this.displayMesIndex;
    this.selecaoAno = this.displayAno;
  }
}
